import {
  autditTrails,
  BOA_KEY,
  SQW_KEY,
  VERSION,
} from "../../constants/ApiUrls";
import { getData, updateData } from "../../networkManager/NetworkManager";

export const getAutditTrail = async (id) => {
  return await getData(
    BOA_KEY + VERSION + `boa/${id}/${autditTrails.AUDIT_TRAIL}`
  );
};

export const updateAuditTrails = (data, id) => {
  return updateData(
    BOA_KEY + VERSION + `boa/${id}/${autditTrails.INACTIVE_AUDIT_TRAILS}`,
    data
  );
};
export const getStatusQuoAutditTrail = async (id) => {
  return await getData(
    SQW_KEY + VERSION + `statusquo/${id}/${autditTrails.AUDIT_TRAIL}`
  );
};

export const updateStatusQuoAuditTrails = (data, id) => {
  return updateData(
    SQW_KEY + VERSION + `statusquo/${id}/${autditTrails.INACTIVE_AUDIT_TRAILS}`,
    data
  );
};
